import actionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import { TTagAction, TTagsAction, ProjectTagsState } from './types';

const INITIAL_STATE = {
  tags: [],
  isFetchingProjectTags: false,
};

export const reducers = {
  fetchProjectTags: createAsyncRequestReducer(actionTypes.FETCH_PROJECT_TAGS),
  createProjectTag: createAsyncRequestReducer(actionTypes.CREATE_PROJECT_TAG),
  deleteProjectTag: createAsyncRequestReducer(actionTypes.DELETE_PROJECT_TAG),
  updateProjectTag: createAsyncRequestReducer(actionTypes.UPDATE_PROJECT_TAG),

  syncReducers: createReducer(INITIAL_STATE, {
    [actionTypes.SET_PROJECT_TAGS]: (
      state: ProjectTagsState,
      action: TTagsAction,
    ) => {
      return {
        ...state,
        tags: action.tags,
      };
    },
    [actionTypes.SET_PROJECT_TAG]: (
      state: ProjectTagsState,
      { tag }: TTagAction,
    ) => {
      const newTags = [...state.tags];
      if (tag.id) {
        const tagIndex = newTags.findIndex(t => t.id === tag.id);
        if (tagIndex > -1) {
          newTags.splice(tagIndex, 1, tag);
        } else {
          newTags.unshift(tag);
        }
      }
      return {
        ...state,
        tags: newTags,
      };
    },
    [actionTypes.UNSET_PROJECT_TAG]: (
      state: ProjectTagsState,
      { tag }: TTagAction,
    ) => {
      const newTags = [...state.tags];
      if (tag.id) {
        const tagIndex = newTags.findIndex(t => t.id === tag.id);
        if (tagIndex > -1) {
          newTags.splice(tagIndex, 1);
        }
      }
      return {
        ...state,
        tags: newTags,
      };
    },
  }),
};

export default combineReducers(reducers);
